
import React, { useEffect, useState, useRef } from 'react';
import Scroll from '../scroll/scroll';

import QuoteBox from "../quoteBox/quoteBox";
import sectionDivider from '../../assets/solutions/section_divider.png';
import ContactSection from '../contactSection/contactSection';
import CardGrid from "../imageCardGrid/cardGrid";
import generateCardContent from "./cardContent";


const ContestedLogistics = () => {
    const introRef = useRef();
    const contestedLogisticsRef = useRef();
    const contactUsRef = useRef();
    const [cardsContent,setCardsContent] = useState({});
    useEffect(() => {
        let cards = generateCardContent();
        setCardsContent(cards);
    },[])

    return (
        <>
            <section id="intro" className="section" ref={introRef}>
                <div className="middle_wide auto">
                    <span className="catchphrase duborics text_middle">
                        Industry Solutions: <br/> Contested Logistics
                    </span>
                    <QuoteBox>
                        As missions grow more complex and contested, planners need a sustainment tool that keeps up with the pace of change
                        and scale of information in contested environments to augment the planning process with rapid exploration of courses
                        of action and sustainment plans, and uncover risk before operations are disrupted.
                    </QuoteBox>
                </div>
            </section>
            <section id="mobility" className="section" ref={contestedLogisticsRef}>
                <div className="solution_section_title">
                    <span className="header_3">Futurescape for contested Logistics</span>
                    <img src={sectionDivider} alt=""></img>
                </div>
                <div className="section_content" style={{ marginBottom: '3rem'}}>
                    <span className="text">
                        FutureScape<sup className="TM">TM</sup> is Deloitte’s decision-support platform designed to create digital replicas of complex,
                        contested environments—such as combat theaters and command echelons—to test the impact of new strategies
                        and resourcing decisions on mission outcomes, enabling leaders to assess the efficacy of their plans and
                        identify their most resilient strategies.
                    </span>
                    <br></br><br></br>
                    <span className={'bold text'}>
                        The potential result: improved mission readiness at every level of operation—delivering data-backed insights that save time,
                        money, and lives.
                    </span>
                </div>
                <div className="solution_section_title">
                    <span className="header_4">With FutureScape for Contested Logistics, teams can: </span>
                </div>
                <CardGrid content={cardsContent}/>
            </section>
            <section id="contactUs" ref={contactUsRef}>
                <ContactSection/>
            </section>
            <Scroll
                scrollSection={[introRef, contestedLogisticsRef, contactUsRef]}
            />
        </>
    )
}

export default ContestedLogistics;